/**
 * YO-PROMO
 *
 * Bootstraps YO-PROMO-BANNER component.
 */
customElements.get('yo-promo') ??
  customElements.define(
    'yo-promo',
    class YO_Promo extends HTMLElement {
      constructor() {
        super();

        this.ns = '[YO/Promo]';

        this.banner = this.querySelector('yo-promo-banner');

        if (this.banner) {
          if (window.matchMedia('(max-width: 767px)').matches) {
            document.querySelector('.product-block product-form').appendChild(this.banner);
          } else {
            document
              .querySelector('.product-main--big-image .right-bottom .product-block:first-child')
              .prepend(this.banner);
          }
        }

        console.log(`${this.ns} Init`, this);
      }
    }
  );

/**
 * YO-PROMO-BANNER
 */
customElements.get('yo-promo-banner') ??
  customElements.define(
    'yo-promo-banner',
    class YO_Promo extends HTMLElement {
      constructor() {
        super();

        this.ns = '[YO/PromoBanner]';

        console.log(`${this.ns} Init`, this);
      }
    }
  );
